import React from "react";
import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles({
    root: {
        backgroundColor: 'rgb(84, 86, 95)',
        color: 'white'
    },
});

const TransferProcess = ({currency, ticketTransferPrice}) => {
    const classes = useStyles();

    return (<>
        <h3 className={classes.root} style={{paddingLeft: 0, paddingRight: 0}}>
            HOW THE TRANSFER PROCESS WORKS
        </h3>
        <div style={{marginBottom: '10px'}}>
            1. We will provide you with a unique link that allows anyone with the link to purchase your ticket.
        </div>
        <div style={{marginBottom: '10px'}}>
            2. Share the link with potential buyers.
        </div>
        <div style={{marginBottom: '10px'}}>
            3. Once someone buys your ticket through the provided link, you will receive a refund
            of <b>{currency}{ticketTransferPrice}</b> directly onto the credit/debit card that was used to purchase the
            ticket within
            5 to 10 business days.
        </div>
        <div style={{marginBottom: '10px'}}>
            4. Once your ticket is sold, the new buyer will have full ownership and control of the ticket.
            The sale cannot be reversed.
        </div>
        <b>You can disable the transfer link at any time. Your ticket will remain valid until it is sold.</b>
    </>);
}
export default TransferProcess;
